module.exports = __webpack_public_path__ + "zvetseni-prsou_17_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_17_before.jpg
// module id = 1308
// module chunks = 0